import React, { useCallback } from "react"
import { css } from "@emotion/css"
import { DraggableItems, DraggableItem } from "components/DraggableItems"
import { IdType } from "react-table"
import Typography from "@material-ui/core/Typography"
import Checkbox from "@material-ui/core/Checkbox"

import { Surface } from "components/Surface"

type Props = {
  columns: DraggableItem[]
  onChange: (
    updater:
      | IdType<DraggableItem>[]
      | ((columnOrder: IdType<DraggableItem>[]) => IdType<DraggableItem>[]),
  ) => void
  onRemove: (id: string) => void
  label?: string
}

export const TableColumnOrder = ({
  columns,
  onChange,
  onRemove,
  label,
}: Props) => {
  const onReorder = useCallback(
    (
      columns: Array<{
        id: IdType<DraggableItem>
        name: string
      }>,
    ) => {
      const ordered = columns.map((c) => c.id)
      onChange(ordered)
    },
    [onChange],
  )

  return (
    <Surface variant="custom" size="custom" className={styles.boxOverflow}>
      {label ? (
        <Typography variant="body1" className={styles.title}>
          {label}
        </Typography>
      ) : null}
      <DraggableItems
        items={columns}
        onReorder={onReorder}
        direction="vertical"
        itemClassName={styles.item}
        renderItem={(item) => (
          <Surface
            variant="custom"
            size="custom"
            display="grid"
            gridAutoFlow="column"
            gridAutoColumns="max-content"
            alignItems="center"
          >
            <Checkbox
              color="primary"
              checked={true}
              disabled={item.disabled}
              onChange={(_) => onRemove(item.id)}
            />
            <Typography variant="body2">{item?.name}</Typography>
          </Surface>
        )}
      />
    </Surface>
  )
}

const styles = {
  title: css`
    font-size: 0.8125rem;
    margin: -1.2rem 0.1rem 0.5rem;
    position: fixed;
  `,
  item: css`
    border: 1px solid var(--light-grey);
    padding: 0px;
    min-width: 300px;
    background-color: var(--white);
    margin: 2px 0;
  `,
  boxOverflow: css`
    overflow: unset;
  `,
}
